import React, { useContext } from 'react'

import { ReactComponent as WarningTriangle } from '@sketch/icons/warning-triangle-64'

import { ErrorMessage, Link, Section, ModalContext } from '@sketch/components'

import { ScimPersonalAccessTokenList } from './components'
import { CreateScimPersonalAccessTokenModal } from './modals'

import { StyledButton } from './ManageScimPersonalAccessTokens.styles'

// Operations
import { useGetScimPersonalAccessTokens } from './operations'

const ManageScimPersonalAccessTokens: React.FCC<{}> = () => {
  const { showModal } = useContext(ModalContext)
  const { personalTokens, loading, error } = useGetScimPersonalAccessTokens()

  const handleCreateTokenClick = () => {
    showModal(CreateScimPersonalAccessTokenModal, {})
  }

  return (
    <Section
      title="SCIM API Personal Access Tokens"
      text={
        <div>
          Personal access tokens enable you to manage Sketch users using a SCIM
          API.{' '}
          <Link
            // TODO: Update link when docs are available
            href="http://www.sketch.com/docs/workspaces/managing-your-sketch-account/#two-factor-authentication-2fa"
            isUnderlined
            external
          >
            Learn more
          </Link>
        </div>
      }
      action={
        <StyledButton
          variant="secondary"
          onClick={handleCreateTokenClick}
          size="40"
          disabled={loading}
        >
          Create Token…
        </StyledButton>
      }
    >
      {error && (
        <ErrorMessage
          icon={<WarningTriangle />}
          iconSize="medium"
          title="Could not load tokens"
          description="Something went wrong loading personal tokens. Please refresh the page or try again later"
        />
      )}
      {!loading && personalTokens && personalTokens.length > 0 && (
        <ScimPersonalAccessTokenList tokens={personalTokens} />
      )}
    </Section>
  )
}

export default ManageScimPersonalAccessTokens
